import { Api, getApiHost } from '../../../utils/index.js';
import { uriEncode } from '../../../utils/index.js';
export class CalveraTelemetryService {
    async send(telemetryEvent, encodeEvent = true) {
        const telemetryEvt = encodeEvent ? await uriEncode(telemetryEvent) : telemetryEvent;
        if (location.hostname === 'localhost') {
            console.log(`[TELEMETRY EVENT]${encodeEvent ? ' : ENCODED' : ''}`, telemetryEvt);
            return;
        }
        const req = new XMLHttpRequest();
        const url = `${getApiHost()}${Api.CAL_TELEMETRY}/events`;
        req.open('POST', url, true);
        req.setRequestHeader('Content-Type', 'application/json');
        req.send(JSON.stringify(telemetryEvt));
    }
}
export class TelemetryEvent {
    eventCategory;
    eventParentId;
    eventType;
    id;
    value;
    constructor(eventCategory, eventParentId, eventType, id = null, value) {
        this.eventCategory = eventCategory;
        this.eventParentId = eventParentId;
        this.eventType = eventType;
        this.id = id;
        this.value = value;
    }
}
